import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { Content } from '../../models';
import { ContentService } from './../../services/content.service';

@Component({
  selector: 'content-details-card',
  templateUrl: './content-details-card.component.html',
})
export class ContentDetailCardComponent {
  @Input() public content: Content;
}
